let itm = {
  // bcg: require('../bcg_unit.png'),
  bcg2: require('./u4.png'),
  name: 'Bedtime story',
  items: [],
};

export default itm;
